import { Vue, store, storeFuns, api, apiFuns } from "sw-hic";
storeFuns.init({
  state: {
    enum: {
      payment: ["现金", "支票", "转账", "银行卡"],
      RefundType: ["原渠道退回", "现金"],
      NativePlaceStreet: ["街道1"],
      HosipitalizationState: ["已登记", "已入住", "已撤销", "已离院", "已结算"],
      CriticalLevel: ["濒危", "危重", "急症", "非急症"],
      PaymentType: ["收费", "退费"],
      depositOccasion: ["入院缴费", "在院补缴", "离院补缴", "离院退费"],
      IpType: ["枚举", "自费", "医保", "医保工伤"],
      BillType: ["出院单据号", "住院号"],
      admissionState: ["已入住", "已撤销", "已离院", "已结算"],
      DiagnosisType: ["西医", "中医"],
      AdviceType: ["药品", "医技", "草药", "嘱托", "转科", "离院"],
      AdviceTerm: ["临时", "长期"],
      RpClass: ["药品", "草药", "检查", "材料", "检验", "治疗"], //["就诊号", "药品", "草药", "检查", "材料", "检验", "治疗"]
      InsuranceRange: ["医保内", "医保外"],
      ConsultationState: ["申请中", "已接受", "已拒绝", "已会诊", "已撤销", "草稿"],
      AdviceState: ["草稿", "待校对", "废弃", "退回", "启用", "暂停", "取消", "待停止", "停止"],
      Condition: ["有", "临床未确定", "情况未明", "无"],
      DiagnosisKind: ["入院", "初步", "出院"],
      UseTime: ["24h", "48h", "72h", "96h", "5天", "≥6天"],
      IsCheck: ["已送检，结果未回", "执行送检", "不送检"],
      FromType: ["其他医疗机构转入", "门诊", "急诊", "其他"],
      TermList: ["长期", "临时"],
      SpecialType: ["转科", "出院"],
      IpLeaveMode: ["出院", "转院", "死亡"],
      IpLeaveStatus: ["治愈", "未愈", "好转", "死亡"],
      ConsulationType: ["精神科", "普通科室"],
      PatientGroup: ["留置看护", "武警看护"],
      OutType: ["外出就诊", "外出住院"],
      LisRecordState: ["待接收", "待检验", "样本拒收", "报告发出"],
      PacsRecordState: ["待检查", "报告发出"],
    },
  },
  getters: {}, // 可以删除
  mutations: {}, // 可以删除
  actions: {}, // 可以删除
});
api.Storehouse = apiFuns.genStandard("storehouse", "/api/drug", true);
storeFuns.genDict("Storehouse", () => api.Storehouse.query({ type: "药房" }));
api.Frequency = apiFuns.genStandard("frequency", "/api/md", true);
storeFuns.genDict(
  "DrugFrequency",
  () => api.Frequency.query({ forIp: true }),
  "name",
  "code",
  "shortCode",
  (store, dict) => {
    dict.items.forEach((item) => {
      item.text = `${item.name} ${item.dailyTime}`;
      item.code = item.code;
      item.shortCode = item.shortCode;
      item.value = item.code;
    });
    store.commit("dict", dict);
  }
);
export default store;

// 常驻一个消息处理，定时刷新获取最新医嘱情况
let msg = new Vue({
  data() {
    return {
      execTime: null,
    };
  },
  methods: {
    getNew() {
      if (!store.getters.user) return;
      const h = this.$createElement;
      apiFuns
        .get("/api/ip/advice", {
          deptCode: store.getters.user.deptCode,
          state: "退回",
          ifDetail: false,
          isMaster: true,
          updateDateStart: this.execTime,
        })
        .then((res) => {
          this.execTime = this.$utils.Dt.now();
          if (res.items.length) {
            this.$notify({
              // offset: 50,
              position: "bottom-right",
              duration: 0,
              title: "",
              type: "warning",
              message: h("el-link", { props: { href: "/#/patient", type: "warning" }, attrs: { style: "margin-top:-0.5rem; " } }, `${res.items.length} 条医嘱被退回`),
            });
            store.state.notifyIpNos = res.items.map((item) => item.ipNo);
          }
        });
    },
  },
});
msg.getNew();
setInterval(() => {
  msg.getNew();
}, store.getters.setting?.refreshSpan || 60000);

// 常驻一个消息处理，定时刷新获取Lis处理提醒
let msgLis = new Vue({
  data() {
    return {
      notification: null,
    };
  },
  methods: {
    getNew() {
      apiFuns
        .get("/api/proxy/lisRecord/warning", {})
        .then((res) => {
          if (this.notification) {
            this.notification.close();
            this.notification = null;
          }
          if (res.criticals.length) {
            this.show(res.criticals.length, "处理", "error", "danger");
          }
        });
    },
    show(cnt, act, type, link) {
      const h = this.$createElement;
      this.notification = this.$notify({
        // offset: 50,
        position: "bottom-left",
        duration: 0,
        title: "",
        type: type,
        message: h("el-link", { props: { href: "/#/testCritical", type: link }, attrs: { style: "margin-top:-0.5rem; " } }, `${cnt} 条检验危急值需${act}`),
      });
    },
  },
});
msgLis.getNew();
setInterval(() => {
  msgLis.getNew();
}, 30000);
